// extracted by mini-css-extract-plugin
export default {"parentContainer":"About_parentContainer__EA67G","head":"About_head__bpesE"};